module.exports = __webpack_public_path__ + "img/SG.adf926fc.png";